import { render, staticRenderFns } from "./#mail-detail.vue?vue&type=template&id=96c6390e&"
import script from "./#mail-detail.vue?vue&type=script&lang=js&"
export * from "./#mail-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports